import CatchyApp from "@catchy/ui/src/CatchyApp";
import "@catchy/app-core/src/busFont.css";
import "@catchy/ui/styles/product.css";
import "@/styles/globals.css";
import "@/styles/maplibre.css";

export default CatchyApp;
